import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { HttpErrorResponse } from "../../../types/responses";
import { useApiPssLogoPicture } from "../datasources/_pss.logopicture.api.slice";

export interface ApiRegisterResponse {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  error: HttpErrorResponse | undefined;
  duplicate: {
    code: string | null;
    value: string | null;
    key: string | null;
  };
}

const usePssLogoSubmitRepo = () => {
  const [api, repository] = useApiPssLogoPicture();
  const httpError = repository.error
    ? ((repository.error as FetchBaseQueryError).data as HttpErrorResponse)
    : undefined;

  // Handle code:ERR_DUP_ENTRY
  const error = httpError?.message;
  const duplicateCodeRegex = /(ER_\w+)/;
  const duplicateValueRegex = /'([^']*)'/;
  const duplicateKeyRegex = /for key '([^']*)'/;

  const duplicateCodeMatch = error?.match(duplicateCodeRegex);
  const duplicateEmailMatch = error?.match(duplicateValueRegex);
  const duplicateKeyMatch = error?.match(duplicateKeyRegex);

  const duplicateCode = duplicateCodeMatch ? duplicateCodeMatch[1] : null;
  const duplicateValue = duplicateEmailMatch ? duplicateEmailMatch[1] : null;
  const duplicateKey = duplicateKeyMatch ? duplicateKeyMatch[1] : null;

  return [
    {
      ...repository,
      error: httpError,
      duplicate: duplicateCode
        ? {
            code: duplicateCode,
            value: duplicateValue,
            key: duplicateKey,
          }
        : null,
    },
    api,
  ] as const;
};

export default usePssLogoSubmitRepo;
